import React from 'react'

import { useNavigate } from '@lib/react-router-dom'

import { SignupWarningMessages } from '@pages/Signup/Components/SignupWarningMessages'
import { CompanyDetailsTemplate } from '@pages/Signup/Pages/CompanyDetails/CompanyDetailsTemplate'

import { useSignup } from '@context/SignupContext'

import { useFetchRegulators } from '@hooks/useFetchRegulators'

import { Loading } from '@shared/components/Loading/Loading'

import { CompanyDetailsStep3Form, CompanyDetailsStep3FormValues } from './CompanyDetailsStep3Form'

interface OuterProps {
  onSubmit(values: CompanyDetailsStep3FormValues): void
  submitLoading?: boolean
}

export const CompanyDetailsStep3Page: React.FC<OuterProps> = (props) => {
  const { onSubmit, submitLoading } = props
  const { signupData } = useSignup()
  const navigate = useNavigate()

  const { data: regulators = [], isLoading } = useFetchRegulators()

  return (
    <CompanyDetailsTemplate
      lead={signupData.lead}
      step={3}
      totalSteps={signupData.totalSteps.companyDetails}
      goBack={() => navigate('/sign-up/company-details/legal')}
    >
      <SignupWarningMessages leadTypeId={signupData.lead?.type?.id} />
      <Loading isLoading={isLoading}>
        {regulators && (
          <CompanyDetailsStep3Form
            initialValues={signupData.corporateValues}
            onSubmit={onSubmit}
            submitLoading={submitLoading}
            regulators={regulators}
          />
        )}
      </Loading>
    </CompanyDetailsTemplate>
  )
}
